import aa from 'search-insights';
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares';

export const attachInsightsMiddleware = ( search ) => {
	if ( parseInt( MWC_AIS.current_user, 10 ) > 0 ) {
		aa( 'setUserToken', 'woo-' + MWC_AIS.current_user );
	}

	search.use( createInsightsMiddleware( { insightsClient: aa } ) );
};
